import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../pages/DashBoard/Dashboardpage";
import Login from "../pages/Auth/LoginPage";
import ApprovalPage from "../pages/Approvals/Approvalpage";
import ApprovalDetailsPage from "../pages/Approvals/ApprovalDetailpage";
import PetOwners from "../pages/User/Petowner/PetOwner";
import VeterinarianList from "../pages/User/Veterinarians/vetenerian";
import PaymentDashboard from "../pages/DashBoard/Payments";
import SupportDashboard from "../pages/DashBoard/Support";
import PromotionsPage from "../pages/DashBoard/Promotions";
import DeliveryDashboard from "../pages/DashBoard/DeliveryPartners";
import OrderListPage from "../pages/DashBoard/OrderlistPage";
import OrderDetailsPage from "../pages/DashBoard/OrderDetails";
import CouponForm from "../Forms/CoupunsForm";
import CouponDetailsPage from "../pages/Coupons/CoupoundetailsPage";
import PetsList from "../pages/User/Pets/Pets";
import PetServices from "../pages/Appointment/PetServicesManager";
import PetServiceOrderDetails from "../pages/PetService/PetServiceOrderDetails";
import UsersPage from "../pages/User/UsersPage";
import AppointmentsPage from "../pages/Appointment/AppointmentsPage";
import CodesPage from "../pages/Codes/codes";
import ProductList from "../pages/Products/Products";
import ProductView from "../pages/Products/ProductsView";
import Reviewmain from "../pages/Review/Reviewmain";
import CouponsMainPage from "../pages/Coupons/CouponsMainPage";
import MastersList from "../pages/Masters/Masters";
import MasterDetails from "../pages/Masters/MasterDetails";
import AvailabilityScreen from "../pages/Availability/Availabilty";
import SendNotificationForm from "../pages/Notificationmanagement/SendNotificationForm";
import NotificationManagement from "../pages/Notificationmanagement/NotificationsPage";
import SettlementPage from "../pages/Settlement/SettlementPage";
import SettlementViewPage from "../pages/Settlement/SettlementViewPage";
import SosPage from "../pages/sos/SosPage";
import AddSosForm from "../pages/sos/AddSosForm";
import PetOwnerPage from "../pages/User/Petowner/PetOwnerDetailspage";
import RefundsPage from "../pages/Refund/RefundsPage";
import RefundDetailsPage from "../pages/Refund/RefundDetailsPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/orders" element={<OrderListPage />} />
      <Route path="/orders/:orderId" element={<OrderDetailsPage />} />
      <Route path="/codes" element={<CodesPage />} />
      <Route path="/approvals" element={<ApprovalPage />} />
      <Route path="/approvals/:type/:id" element={<ApprovalDetailsPage />} />
      <Route path="/pet-owners" element={<PetOwners />} />
      <Route path="/pet-owners/:id" element={<PetOwnerPage />} />
      <Route path="/pets-details/:id" element={<PetsList />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/veterinarians" element={<VeterinarianList />} />
      <Route path="/appointments" element={<AppointmentsPage />} />
      <Route path="/pets/details/:id" element={<ApprovalDetailsPage />} />
      <Route path="/veterinarians/details/:id" element={<ApprovalDetailsPage />} />
      <Route path="/vet_charge_codes/details/:id" element={<ApprovalDetailsPage />} />
      <Route path="/service_charge_codes/details/:id" element={<ApprovalDetailsPage />} />
      <Route path="/vendor/details/:id" element={<ApprovalDetailsPage />} />
      <Route path="/service-providers/details/:id" element={<ApprovalDetailsPage />} />
      <Route path="/pet-services" element={<PetServices />} />
      <Route path="/service-orders" element={<AppointmentsPage initialCategory="service" />} />
      <Route path="/pet-service-orders/:id" element={<PetServiceOrderDetails />} />
      <Route path="/coupons" element={<CouponsMainPage />} />
      <Route path="/coupons/new" element={<CouponForm />} />
      <Route path="/coupons/:couponId" element={<CouponDetailsPage />} />
      <Route path="/products" element={<ProductList />} />
      <Route path="/products/view/:productId" element={<ProductView />} />
      <Route path="/promotions" element={<PromotionsPage />} />
      <Route path="/payments" element={<PaymentDashboard />} />
      <Route path="/delivery-partners" element={<DeliveryDashboard />} />
      <Route path="/notifications" element={<NotificationManagement />} />
      <Route path="/notifications/send" element={<SendNotificationForm />} />
      <Route path="/reviews" element={<Reviewmain />} />
      <Route path="/support" element={<SupportDashboard />} />
      <Route path="/masters" element={<MastersList />} />
      <Route path="/masters/:slug" element={<MasterDetails />} />
      <Route path="/availability" element={<AvailabilityScreen />} />
      <Route path="/settlements" element={<SettlementPage />} />
      <Route path="/settlements/:id" element={<SettlementViewPage />} /> 
      <Route path="/sos" element={<SosPage />} />
      <Route path="/sos/add" element={<AddSosForm />} />
      <Route path="/refunds" element={<RefundsPage />} />
      <Route path="/refunds/:id" element={<RefundDetailsPage  />} /> 
    </Routes>
  );
}
